import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
const ObservatoryApp = lazy(() => import("./App"));
import { LandingPage } from "./components/LandingPage";
import { PortalPage, type PortalKind } from "./components/PortalPage";
import { ThemedReadingsPage } from "./components/ThemedReadingsPage";
import { apiUrl } from "./utils/api";
import "./index.css";

const referralCode = new URLSearchParams(window.location.search).get("ref");
if (referralCode && /^nex-[A-Za-z0-9-]{4,64}$/.test(referralCode)) {
  window.localStorage.setItem("nex_referral_code", referralCode);
}

const authToken = new URLSearchParams(window.location.search).get("auth_token");
if (authToken) {
  void fetch(apiUrl("/api/auth/magic-link/verify"), {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-NEX-Referral-Code": window.localStorage.getItem("nex_referral_code") ?? "" },
    credentials: "include",
    body: JSON.stringify({ token: authToken }),
  }).then((response) => {
    const cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete("auth_token");
    window.history.replaceState({}, document.title, cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
    if (response.ok) window.location.reload();
  }).catch(() => undefined);
}

const rootElement = document.getElementById("root");
const isObservatoryRoute = window.location.pathname === "/observatory" || window.location.pathname === "/app";
const portalPaths: Record<string, PortalKind> = { "/portal": "portal", "/profile": "portal", "/subscription": "subscription", "/referrals": "referrals", "/methodology": "methodology", "/commons": "commons", "/privacy": "privacy", "/terms": "terms" };
const portalKind = portalPaths[window.location.pathname];
const readingSlug = window.location.pathname.startsWith("/readings/") ? window.location.pathname.slice("/readings/".length) : window.location.pathname === "/readings" ? "" : null;
if (!rootElement) {
  throw new Error("Failed to locate root mount element '#root'.");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    {isObservatoryRoute ? <Suspense fallback={<div className="flex h-screen items-center justify-center bg-slate-950 text-sm text-cyan-200">Loading the observatory...</div>}><ObservatoryApp /></Suspense> : portalKind ? <PortalPage kind={portalKind} /> : readingSlug !== null ? <ThemedReadingsPage slug={readingSlug || undefined} /> : <LandingPage />}
  </React.StrictMode>
);